import {Button} from '@shared/FormsComponents/Button/Button';

import FailureIcon from './assets/failure.svg';
import SuccessIcon from './assets/success.svg';
import styles from './screens.module.scss';

type Props = {
  title: string;
  description?: string;
  variant?: 'success' | 'error';
  button?: string;
  handleButtonClick?: () => void;
};

export const ResultScreen = ({
  title,
  description,
  variant = 'success',
  button,
  handleButtonClick,
}: Props) => {
  return (
    <div className={styles.root} data-testid={`${variant}_screen`}>
      <img
        src={variant === 'error' ? FailureIcon.src : SuccessIcon.src}
        alt={variant}
      />
      <div>{title}</div>
      <div className={styles.description}>{description}</div>
      {button && (
        <Button
          className={styles.button}
          onClick={handleButtonClick}
          data-testid={'result_screen_button'}
        >
          {button}
        </Button>
      )}
    </div>
  );
};
